import { useState, useEffect } from "react";
import { TextField, Grid, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Categories,
} from "../../../../app/slices/categorySlice";
import { Controller, useForm } from "react-hook-form";

import FilePondInput from "../../../../helpers/FilePondInput";
import { SelectProvince } from "../../../../components/Selectors/SelectProvince";
import {
  HiOutlineFolder,
  HiOutlineIdentification,
  HiOutlineCog6Tooth,
  HiOutlinePhoto,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  SwitchCard,
} from "../../../../components/FormDialog";

const CategoriesForm = () => {
  const _Categories = useSelector((state) => state.categories.category);
  const _SearchBody = useSelector((state) => state.categories.searchBody);
  const _provinces = useSelector((state) => state.provinces.provinces.data);

  const isAdd = _Categories.form.id ? false : true;
  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _Categories.form,
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("is_product", data.is_product ? 1 : 0);
    formData.append("is_transfer", data.is_transfer ? 1 : 0);
    formData.append("province_ids", JSON.stringify(data.province_ids) );
    if (!isAdd) formData.append("_method", "PUT");
    formData.append("name", data.name);
    if (data.logo && data.logo[0].name) formData.append("logo", data.logo[0]);
    if (isAdd) {
      dispatch(Categories.create(formData));
    } else {
      dispatch(Categories.update(data.id, formData, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ..._Categories.form });
  }, [_Categories.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_Categories.dialog}
      onClose={() => {
        handlDialog();
      }}
      icon={<HiOutlineFolder />}
      title={isAdd ? "إضافة فئة" : "تعديل الفئة"}
      subtitle={
        isAdd
          ? "أدخل معلومات الفئة لإضافتها"
          : "قم بتحديث معلومات الفئة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="المعلومات الأساسية">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label=" الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="province_ids"
            control={control}
            render={({ field }) => (
              <SelectProvince
                multiple
                onChange={(e, newValue) => {
                  var ids = newValue.map((x) => x.id);
                  setValue("province_ids", newValue ? ids : []);
                }}
                value={
                  _provinces?.filter((x) =>
                    field.value?.includes(x.id) ? field.value : null
                  )
                }
              />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlineCog6Tooth />} title="الإعدادات">
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_transfer"
            control={control}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label="تحويل الرصيد !"
                onChange={(e) => {
                  setValue("is_transfer", e.target.checked);
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="is_product"
            control={control}
            render={({ field }) => (
              <SwitchCard
                field={field}
                label="المنصة !"
                onChange={(e) => {
                  setValue("is_product", e.target.checked);
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlinePhoto />} title="الشعار">
        <Grid item xs={12}>
          <Controller
            name="logo"
            control={control}
            render={({ field }) => (
              <Box>
                <FilePondInput field={field} required={false} />
              </Box>
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CategoriesForm;
